import { withAuthenticationRequired } from "@auth0/auth0-react";
import { store } from "../store";
import { Grid } from "@mui/material";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import UsersTable from "../components/tables/UsersTable";

function Users() {
  const userDB = useSelector((state) => state.userDB);

  useEffect(() => {
    store.dispatch({
      type: "pageTitle/update",
      payload: "Utilisateurs",
    });

    // No page actions for now - users are auto-created via Auth0
    store.dispatch({ type: "pageActions/update", payload: [] });
  }, [userDB.admin]);

  return (
    <Grid item xs={12}>
      <UsersTable />
    </Grid>
  );
}

export default withAuthenticationRequired(Users);
